export default "__VITE_PUBLIC_ASSET__4b0dfa6b__"